import React from 'react';
import {Button, Label} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import Translate from "../../shared/language/Translate";
import GeneralUtils from '../../shared/utils/GeneralUtils';
import AvField from "../../shared/component/form/AvField";
import {toast} from "react-toastify";
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import SupplierColumn from "../../shared/component/dataTable/columns/SupplierColumn.json";
import SupplierService from "../../shared/service/SupplierService";
import {PhoneField} from "../../shared/component/form/PhoneField";
import {Checkbox} from "primereact/checkbox";
import DataTable from "../../shared/component/dataTable/DataTable";
import '../../shared/styles/SettingsPage.css';
import '../../shared/styles/MasterDetailSave.css';
import FormSection from '../../shared/component/form/FormSection';

const defaultSupplier = {
    id: '',
    name: '',
    status: 'ACTIVE',
    email: '',
    phone: '',
    supplierAccountCode: '',
    vatNumber: '',
    postcode: '',
    includeTax: false,
    useInvoiceBarcode: true,
    readBoxQuantityFromProduct: false,
    deposSupplierBssId: null
};

export default class SupplierSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            supplier: Object.assign({}, defaultSupplier),
            supplierTemp: Object.assign({}, defaultSupplier),
            supplierDetailsSaveButtonRender: true, defaultStatus: 'ACTIVE'
        }
        this.supplierService = new SupplierService();
    }

    componentDidMount() {
        let obj1 = Object.assign({}, defaultSupplier);
        this.setState({
            supplier: obj1, supplierDetailsSaveButtonRender: false,
            supplierTemp: Object.assign({}, obj1)
        });
        this.refresh();

    }

    refresh() {
        this.refDataTable.refresh();
    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        {this.supplierDetails()}
                    </div>
                </AvForm>
            </div>
        );
    }

    delete = () => {
        if (!GeneralUtils.isNullOrEmpty(this.state.supplier.id)) {
            this.supplierService.delete(this.state.supplier.id)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        let obj1 = Object.assign({}, defaultSupplier);
                        this.setState({
                            supplier: obj1, supplierDetailsSaveButtonRender: false,
                            supplierTemp: Object.assign({}, obj1)
                        });
                        this.refresh();
                    }
                });
        }

        return undefined;
    }

    showChangeStatusConfirmDialog = (value) => {
        let defaultStatus = 'PASSIVE';
        if (value) {
            defaultStatus = 'ACTIVE'
        }
        this.setState({
            displayShowStatusConfirmDialog: true,
            defaultStatus: defaultStatus,
            noticeResponse: "Are you sure to delete?"
        });
    }

    supplierDetails() {
        return (
            <>
                <div className="settings-page__header">
                    <h1 className="settings-page__title">Supplier</h1>
                </div>

                <div className="settings-page__panel master-detail-save">
                    <ModalConfirm header='Warning' ok='OK' onOkClick={this.delete}
                                  onCancelClick={() => this.setState({displayShowStatusConfirmDialog: false})}
                                  show={this.state.displayShowStatusConfirmDialog}
                                  message={this.state.noticeResponse}/>

                    <div className="master-detail-save__split">
                        <div className="master-detail-save__list">
                            <FormSection title="Suppliers" className="master-detail-save__list-section">
                                {GeneralUtils.checkPrivilege("post_inventory/supplier") &&
                                    <div className="settings-page__toolbar settings-page__toolbar--start master-detail-save__list-toolbar">
                                        <Button color="outline-primary" className="settings-page__btn--add" onClick={() => {
                                            this.addNew();
                                        }}>
                                            <Translate contentKey="entity.action.add">Add</Translate>
                                        </Button>
                                    </div>}
                                {GeneralUtils.checkPrivilege("put_inventory/supplier") &&
                                    <div className="settings-page__table-wrap master-detail-save__list-table">
                                        <DataTable ref={(elem) => this.refDataTable = elem} fields={SupplierColumn.fields}
                                                   objectName={SupplierColumn.name}
                                                   dataURL="inventory/supplier/all"
                                                   rows={5}
                                                   onDataSelect={this.onDataSelect}
                                                   selectionMode="single"
                                                   loading={this.state.loading}/>
                                    </div>}
                            </FormSection>
                        </div>

                        <div className="master-detail-save__details">
                            <div className="master-detail-save__details-body">
                                <FormSection title="Supplier Details">
                        <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__filter-row--wide settings-page__form-fields">
                            <div className="settings-page__filter-field">
                                <AvGroup>
                                    <Label for="supplier-name">
                                        <Translate contentKey="tax.tradingName">Name</Translate>
                                        <span style={{color: 'red'}}> (*)</span>
                                    </Label>
                                    <AvField
                                        id="supplier-name"
                                        type="text"
                                        className="form-control"
                                        name="name"
                                        disabled={!this.state.supplierDetailsSaveButtonRender}
                                        validate={{
                                            maxLength: {
                                                value: 255,
                                                errorMessage: "You can enter up to 255 characters in this field."
                                            }
                                        }}
                                        value={this.state.supplier.name}
                                        onChange={this.__handleChange}/>
                                </AvGroup>
                            </div>
                            <div className="settings-page__filter-field">
                                <AvGroup>
                                    <Label for="supplier-code">
                                        <Translate contentKey="tax.tradingName">Code</Translate>
                                    </Label>
                                    <AvField
                                        id="supplier-code"
                                        type="text"
                                        className="form-control"
                                        name="supplierAccountCode"
                                        disabled={!this.state.supplierDetailsSaveButtonRender}
                                        validate={{
                                            maxLength: {
                                                value: 255,
                                                errorMessage: "You can enter up to 255 characters in this field."
                                            }
                                        }}
                                        value={this.state.supplier.supplierAccountCode}
                                        onChange={this.__handleChange}/>
                                </AvGroup>
                            </div>
                            <div className="settings-page__filter-field">
                                <AvGroup>
                                    <Label for="supplier-email">
                                        <Translate contentKey="merchantAccount.emailAddress">Email</Translate>
                                    </Label>
                                    <AvField
                                        id="supplier-email"
                                        type="email"
                                        className="form-control"
                                        name="email"
                                        disabled={!this.state.supplierDetailsSaveButtonRender}
                                        validate={{
                                            minLength: {
                                                value: 5, errorMessage: "Not Valid Email"
                                            }, maxLength: {
                                                value: 255,
                                                errorMessage: "You can enter up to 255 characters in this field."
                                            }
                                        }}
                                        value={this.state.supplier.email}
                                        onChange={this.__handleChange}/>
                                </AvGroup>
                            </div>
                            <div className="settings-page__filter-field">
                                <AvGroup>
                                    <Label for="supplier-vat">
                                        <Translate contentKey="tax.tradingName">Vat Number</Translate>
                                    </Label>
                                    <AvField
                                        id="supplier-vat"
                                        type="text"
                                        className="form-control"
                                        name="vatNumber"
                                        disabled={!this.state.supplierDetailsSaveButtonRender}
                                        value={this.state.supplier.vatNumber}
                                        onChange={this.__handleChange}/>
                                </AvGroup>
                            </div>
                            <div className="settings-page__filter-field">
                                <AvGroup>
                                    <Label for="supplier-phone">
                                        <Translate contentKey="contactManagement.mobilePhone">Phone</Translate>
                                    </Label>
                                    <PhoneField kind="mobile"
                                                disabled={!this.state.supplierDetailsSaveButtonRender}
                                                name="phone" errorMessage="Not Valid Phone Number"
                                                value={this.state.supplier.phone}
                                                onChange={this.__handleChange}/>
                                </AvGroup>
                            </div>
                        </div>

                        <div className="settings-page__checkbox-grid">
                            <div className="settings-page__checkbox-item">
                                <Checkbox onChange={(e) => this.setChecked("includeTax", e.checked)}
                                          name="includeTax"
                                          disabled={!this.state.supplierDetailsSaveButtonRender}
                                          checked={this.state.supplier.includeTax}/>
                                <Label>
                                    <Translate contentKey="productfirstName">Inc VAT</Translate>
                                </Label>
                            </div>
                            <div className="settings-page__checkbox-item">
                                <Checkbox onChange={(e) => this.setChecked("useInvoiceBarcode", e.checked)}
                                          name="useInvoiceBarcode"
                                          disabled={!this.state.supplierDetailsSaveButtonRender}
                                          checked={this.state.supplier.useInvoiceBarcode}/>
                                <Label>
                                    <Translate contentKey="productfirstName">Use Invoice Barcode</Translate>
                                </Label>
                            </div>
                            <div className="settings-page__checkbox-item">
                                <Checkbox onChange={(e) => this.setChecked("readBoxQuantityFromProduct", e.checked)}
                                          name="readBoxQuantityFromProduct"
                                          disabled={!this.state.supplierDetailsSaveButtonRender}
                                          checked={this.state.supplier.readBoxQuantityFromProduct}/>
                                <Label>
                                    <Translate contentKey="productfirstName">Ignore Box Quantity</Translate>
                                </Label>
                            </div>
                        </div>

                        <div className="settings-page__actions master-detail-save__form-actions">
                            {GeneralUtils.checkPrivilege("post_inventory/supplier") && this.state.supplierDetailsSaveButtonRender == false && !GeneralUtils.isNullOrEmpty(this.state.supplier.id) &&
                                <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                                    this.setState({supplierDetailsSaveButtonRender: true});
                                }}>
                                    <Translate contentKey="entity.action.add">Edit</Translate>
                                </Button>}
                            {GeneralUtils.checkPrivilege("post_inventory/supplier") && this.state.supplierDetailsSaveButtonRender &&
                                <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                                    this.saveSupplier();
                                }}>
                                    <Translate contentKey="entity.action.add">Save</Translate>
                                </Button>}
                            {GeneralUtils.checkPrivilege("delete_inventory/supplier/_id") && this.state.supplierDetailsSaveButtonRender == false && !GeneralUtils.isNullOrEmpty(this.state.supplier.id) &&
                                <Button color="outline-danger" className="settings-page__btn--delete" onClick={() => {
                                    this.showChangeStatusConfirmDialog(true);
                                }}>
                                    <Translate contentKey="entity.action.add">Delete</Translate>
                                </Button>}
                            {GeneralUtils.checkPrivilege("post_inventory/supplier") && this.state.supplierDetailsSaveButtonRender &&
                                <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                                    let obj1 = this.state.supplierTemp;
                                    this.setState({
                                        supplier: Object.assign({}, obj1), supplierDetailsSaveButtonRender: false
                                    });
                                }}>
                                    <Translate contentKey="entity.action.cancel">Cancel</Translate>
                                </Button>}
                        </div>
                                </FormSection>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    onDataSelect = (data) => {
        this.supplierService.findById(data.id).then(response => {
            this.setState({
                supplier: Object.assign({}, response),
                supplierDetailsSaveButtonRender: false,
                supplierTemp: Object.assign({}, response)
            });

        });

    }
    saveSupplier = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.supplier.name)) {
            return toast.warn("Please fill the required fields!");
        } else {
            if (!GeneralUtils.isNullOrEmpty(this.state.supplier.id)) {
                this.supplierService.update(this.state.supplier)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            this.setState({
                                supplierDetailsSaveButtonRender: false, supplier: response,
                                supplierTemp: Object.assign({}, response)

                            });
                            this.refresh();
                        }
                    });
            } else {
                this.supplierService.create(this.state.supplier)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            this.setState({
                                supplierDetailsSaveButtonRender: false, supplier: response,
                                supplierTemp: Object.assign({}, response)
                            });
                            this.refresh();
                        }
                    });
            }
        }

    }

    addNew() {
        let obj1 = Object.assign({}, defaultSupplier);
        this.setState({
            supplier: obj1, supplierDetailsSaveButtonRender: true, supplierTemp: Object.assign({}, obj1)
        });
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let supplier = this.state.supplier;
        supplier[e.target.name] = value;
        this.setState({supplier: supplier});
    }

    setChecked = (name, value) => {
        let supplier = this.state.supplier;
        supplier[name] = value;
        this.setState({supplier: supplier});
    }

}

